import React from 'react';
import TestPageComponent from '../components/TestPageComponent/TestPageComponent';

function TestPage() {
  return (
    <div>
      <TestPageComponent />
    </div>
  );
}

export default TestPage;
